export const capitalCase = (text) => {
  return text.toLowerCase().replace(/\b\w/g, char => char.toUpperCase());
};
